import React, { useEffect } from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page">
      <div className="contact-container">
        
        {/* Banner Section */}
        <div className="contact-banner-section">
          <div className="contact-desc">
            <h1>Contact Us</h1>
            <span>Support team ready to help</span>
            <p>
              We are a highly agile and nimble footed organization which believes in a collaborative approach to solve problems of the world. And that is why the culture of customer feedback and satisfaction ranks high on our agenda. We are happy to help you round the clock to the best of our ability.
            </p>
          </div>
          <div className="contact-img">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          </div>
        </div>

        {/* Help Section */}
        <div className="contact-help-section">
          <div className="contact-flex-container">
            
            {/* Chat Box */}
            <div className="contact-msg-box">
              <div className="contact-icon-section"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div>
              <div className="contact-msg-txt">
                <h2>Need Any Assistance?</h2>
                <p>Industrybull is here to help you</p>
                <a 
                  href="https://api.whatsapp.com/send?phone=+919999049135&text=Hi" 
                  className="contact-btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  CHAT NOW
                </a>
              </div>
            </div>

            {/* FAQ Box */}
            <div className="contact-msg-box">
              <div className="contact-icon-section"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></div>
              <div className="contact-msg-txt">
                <h2>FAQ's</h2>
                <p>You can manage your orders in Orders section</p>
                <button className="contact-btn contact-btn-outline">
                  VIEW ALL
                </button>
              </div>
            </div>

          </div>
        </div>

        {/* Office Locations */}
        <div className="contact-ofc-location-container">
          <h2 className="contact-ofc-heading">Our Office Addresses</h2>
          
          <div className="contact-locations-grid">
            <div className="contact-location-card">
              <span>Headquarter</span>
              <p className="subheading">Singapore</p>
              <p>7 Temasek Boulevard #12-02A Suntec Tower One, 038987, Singapore</p>
            </div>
            
            <div className="contact-location-card">
              <span>India Office</span>
              <p className="subheading">India</p>
              <p>Smartworks Corporate Park (Tower B), 1st Floor, Sector 125, Noida 201303, Uttar Pradesh</p>
            </div>
            
            <div className="contact-location-card">
              <span>UAE Office</span>
              <p className="subheading">UAE</p>
              <p>Khalifa Industrial Zone (Kizad), Abu Dhabi, UAE</p>
            </div>
          </div>
        </div>

        {/* Footer Support */}
        <div className="contact-footer-support">
          <p className="contact-customer-support">
            To get in touch with our customer support, call us at +91 8448233444
          </p>
          <p className="contact-call-timing">
            Call Timings:- 11:00 AM to 4:00 PM (Mon to Sat)
          </p>
        </div>

      </div>
    </div>
  );
};

export default Contact;
